export default __webpack_public_path__ + "static/media/banner_3.42c4d9ae.png";